export const srcKeys = [
  {
    index: 0,
    style: {
      top: "10.7%",
      left: "7.1%",
    },
    layers: [{ key: "#00070029" }],
  },
  {
    index: 1,
    style: {
      top: "12.0%",
      left: "12.4%",
    },
    layers: [{ key: "#00070035" }],
  },
  {
    index: 2,
    style: {
      top: "12.0%",
      left: "16.7%",
    },
    layers: [{ key: "#0007001E" }],
  },
  {
    index: 3,
    style: {
      top: "10.4%",
      left: "21.0%",
    },
    layers: [{ key: "#0007001F" }],
  },
  {
    index: 4,
    style: {
      top: "12.8%",
      left: "25.8%",
      transform: "rotateZ(12deg)",
    },
    layers: [{ key: "#00070020" }],
  },
  {
    index: 5,
    style: {
      top: "15.8%",
      left: "30.1%",
      transform: "rotateZ(12deg)",
    },
    layers: [{ key: "#00070021" }],
  },
  {
    index: 6,
    style: {
      top: "18.4%",
      left: "34.4%",
      transform: "rotateZ(12deg)",
    },
    layers: [{ key: "#00070022" }],
  },
  {
    index: 31,
    style: {
      top: "21.0%",
      left: "38.8%",
      transform: "rotateZ(12deg)",
    },
    layers: [{ key: "#00070023" }],
  },
  {
    index: 7,
    style: {
      top: "19.4%",
      left: "59.5%",
      transform: "rotateZ(-12deg)",
    },
    layers: [{ key: "#00070024" }],
  },
  {
    index: 8,
    style: {
      top: "16.8%",
      left: "63.9%",
      transform: "rotateZ(-12deg)",
    },
    layers: [{ key: "#00070025" }],
  },
  {
    index: 9,
    style: {
      top: "14.1%",
      left: "68.2%",
      transform: "rotateZ(-12deg)",
    },
    layers: [{ key: "#00070026" }],
  },
  {
    index: 10,
    style: {
      top: "11.2%",
      left: "72.6%",
      transform: "rotateZ(-12deg)",
    },
    layers: [{ key: "#00070027" }],
  },
  {
    index: 11,
    style: {
      top: "10.2%",
      left: "77.3%",
    },
    layers: [{ key: "#0007002D" }],
  },
  {
    index: 12,
    style: {
      top: "11.6%",
      left: "81.6%",
    },
    layers: [{ key: "#0007002E" }],
  },
  {
    index: 13,
    style: {
      top: "11.6%",
      left: "86.0%",
      width: "7.0%",
    },
    layers: [{ key: "#0007002A" }],
  },
  {
    index: 25,
    style: {
      top: "23.3%",
      left: "6.4%",
    },
    layers: [{ key: "#0007004B" }],
  },
  {
    index: 26,
    style: {
      top: "24.8%",
      left: "11.7%",
      width: "5.0%",
    },
    layers: [{ key: "#0007002B" }],
  },
  {
    index: 27,
    style: {
      top: "24.8%",
      left: "18.1%",
    },
    layers: [{ key: "#00070014" }],
  },
  {
    index: 28,
    style: {
      top: "24.4%",
      left: "22.8%",
      transform: "rotateZ(12deg)",
    },
    layers: [{ key: "#0007001A" }],
  },
  {
    index: 29,
    style: {
      top: "27.0%",
      left: "27.1%",
      transform: "rotateZ(12deg)",
    },
    layers: [{ key: "#00070008" }],
  },
  {
    index: 30,
    style: {
      top: "29.6%",
      left: "31.4%",
      transform: "rotateZ(12deg)",
    },
    layers: [{ key: "#00070015" }],
  },
  {
    index: 56,
    style: {
      top: "32.5%",
      left: "35.8%",
      transform: "rotateZ(12deg)",
    },
    layers: [{ key: "#00070017" }],
  },
  {
    index: 57,
    style: {
      top: "33.5%",
      left: "58.2%",
      transform: "rotateZ(-12deg)",
    },
    layers: [{ key: "#0007001C" }],
  },
  {
    index: 32,
    style: {
      top: "30.9%",
      left: "62.5%",
      transform: "rotateZ(-12deg)",
    },
    layers: [{ key: "#00070018" }],
  },
  {
    index: 33,
    style: {
      top: "28.1%",
      left: "66.8%",
      transform: "rotateZ(-12deg)",
    },
    layers: [{ key: "#0007000C" }],
  },
  {
    index: 34,
    style: {
      top: "25.4%",
      left: "71.2%",
      transform: "rotateZ(-12deg)",
    },
    layers: [{ key: "#00070012" }],
  },
  {
    index: 35,
    style: {
      top: "24.0%",
      left: "75.9%",
    },
    layers: [{ key: "#00070013" }],
  },
  {
    index: 36,
    style: {
      top: "24.7%",
      left: "80.2%",
    },
    layers: [{ key: "#0007002F" }],
  },
  {
    index: 37,
    style: {
      top: "24.7%",
      left: "84.6%",
    },
    layers: [{ key: "#00070030" }],
  },
  {
    index: 38,
    style: {
      top: "24.7%",
      left: "88.9%",
      width: "5.0%",
    },
    layers: [{ key: "#00070031" }],
  },
  {
    index: 50,
    style: {
      top: "36.4%",
      left: "5.6%",
    },
    layers: [{ key: "#0007004E" }],
  },
  {
    index: 51,
    style: {
      top: "37.6%",
      left: "10.8%",
      width: "6.0%",
    },
    layers: [{ key: "#00070039" }],
  },
  {
    index: 52,
    style: {
      top: "37.6%",
      left: "18.3%",
    },
    layers: [{ key: "#00070004" }],
  },
  {
    index: 53,
    style: {
      top: "37.8%",
      left: "23.1%",
      transform: "rotateZ(12deg)",
    },
    layers: [{ key: "#00070016" }],
  },
  {
    index: 54,
    style: {
      top: "40.5%",
      left: "27.3%",
      transform: "rotateZ(12deg)",
    },
    layers: [{ key: "#00070007" }],
  },
  {
    index: 55,
    style: {
      top: "43.2%",
      left: "31.6%",
      transform: "rotateZ(12deg)",
    },
    layers: [{ key: "#00070009" }],
  },
  {
    index: 81,
    style: {
      top: "45.7%",
      left: "35.9%",
      transform: "rotateZ(12deg)",
    },
    layers: [{ key: "#0007000A" }],
  },
  {
    index: 82,
    style: {
      top: "45.8%",
      left: "60.2%",
      transform: "rotateZ(-12deg)",
    },
    layers: [{ key: "#0007000B" }],
  },
  {
    index: 58,
    style: {
      top: "43.0%",
      left: "64.6%",
      transform: "rotateZ(-12deg)",
    },
    layers: [{ key: "#0007000D" }],
  },
  {
    index: 59,
    style: {
      top: "40.2%",
      left: "68.9%",
      transform: "rotateZ(-12deg)",
    },
    layers: [{ key: "#0007000E" }],
  },
  {
    index: 60,
    style: {
      top: "37.4%",
      left: "73.1%",
      transform: "rotateZ(-12deg)",
    },
    layers: [{ key: "#0007000F" }],
  },
  {
    index: 61,
    style: {
      top: "37.3%",
      left: "77.8%",
    },
    layers: [{ key: "#00070033" }],
  },
  {
    index: 62,
    style: {
      top: "37.7%",
      left: "82.2%",
    },
    layers: [{ key: "#00070034" }],
  },
  {
    index: 63,
    style: {
      top: "37.7%",
      left: "86.6%",
      width: "8.0%",
    },
    layers: [{ key: "#00070028" }],
  },
  {
    index: 75,
    style: {
      top: "48.8%",
      left: "4.6%",
    },
    layers: [{ key: "#0007004C" }],
  },
  {
    index: 76,
    style: {
      top: "50.3%",
      left: "10.0%",
      width: "8.0%",
    },
    layers: [{ key: "#000700E1" }],
  },
  {
    index: 77,
    style: {
      top: "50.3%",
      left: "19.5%",
    },
    layers: [{ key: "#0007001D" }],
  },
  {
    index: 78,
    style: {
      top: "51.4%",
      left: "24.3%",
      transform: "rotateZ(12deg)",
    },
    layers: [{ key: "#0007001B" }],
  },
  {
    index: 79,
    style: {
      top: "54.5%",
      left: "28.5%",
      transform: "rotateZ(12deg)",
    },
    layers: [{ key: "#00070006" }],
  },
  {
    index: 80,
    style: {
      top: "57.2%",
      left: "32.8%",
      transform: "rotateZ(12deg)",
    },
    layers: [{ key: "#00070019" }],
  },
  {
    index: 106,
    style: {
      top: "59.7%",
      left: "37.1%",
      transform: "rotateZ(12deg)",
    },
    layers: [{ key: "#00070005" }],
  },
  {
    index: 107,
    style: {
      top: "59.6%",
      left: "58.9%",
      transform: "rotateZ(-12deg)",
    },
    layers: [{ key: "#00070005" }],
  },
  {
    index: 108,
    style: {
      top: "56.7%",
      left: "63.4%",
      transform: "rotateZ(-12deg)",
    },
    layers: [{ key: "#00070011" }],
  },
  {
    index: 83,
    style: {
      top: "53.8%",
      left: "67.7%",
      transform: "rotateZ(-12deg)",
    },
    layers: [{ key: "#00070010" }],
  },
  {
    index: 84,
    style: {
      top: "51.0%",
      left: "71.9%",
      transform: "rotateZ(-12deg)",
    },
    layers: [{ key: "#00070036" }],
  },
  {
    index: 85,
    style: {
      top: "50.2%",
      left: "76.7%",
    },
    layers: [{ key: "#00070037" }],
  },
  {
    index: 86,
    style: {
      top: "50.2%",
      left: "81.0%",
    },
    layers: [{ key: "#00070038" }],
  },
  {
    index: 87,
    style: {
      top: "50.2%",
      left: "85.4%",
    },
    layers: [{ key: "#00070052" }],
  },
  {
    index: 88,
    style: {
      top: "50.2%",
      left: "89.8%",
      width: "6.0%",
    },
    layers: [{ key: "#000700E5" }],
  },
  {
    index: 101,
    style: {
      top: "63.3%",
      left: "9.9%",
      width: "4.0%",
    },
    layers: [{ key: "#000700E0" }],
  },
  {
    index: 102,
    style: {
      top: "63.3%",
      left: "15.3%",
      width: "4.0%",
    },
    layers: [{ key: "#000700E3" }],
  },
  {
    index: 103,
    style: {
      top: "65.7%",
      left: "25.5%",
      transform: "rotateZ(12deg)",
      width: "4.0%",
    },
    layers: [{ key: "#000700E2" }],
  },
  {
    index: 105,
    style: {
      top: "71.0%",
      left: "31.0%",
      transform: "rotateZ(12deg)",
      width: "8.0%",
    },
    layers: [{ key: "#0007002C" }],
  },
  {
    index: 109,
    style: {
      top: "70.2%",
      left: "60.1%",
      transform: "rotateZ(-12deg)",
      width: "10.5%",
    },
    layers: [{ key: "#0007002C" }],
  },
  {
    index: 110,
    disabled: false, //
    style: {
      top: "64.0%",
      left: "71.8%",
      transform: "rotateZ(-12deg)",
      width: "4.0%",
    },
    layers: [{ key: "#00920C0B" }],
  },
  {
    index: 111,
    style: {
      top: "63.2%",
      left: "81.1%",
    },
    layers: [{ key: "#00070050" }],
  },
  {
    index: 112,
    style: {
      top: "63.2%",
      left: "85.5%",
    },
    layers: [{ key: "#00070051" }],
  },
  {
    index: 113,
    style: {
      top: "63.2%",
      left: "89.8%",
    },
    layers: [{ key: "#0007004F" }],
  },
];

export const dstKeys = {
  "#00070004": {
    text: [{ text: "A", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070005": {
    text: [{ text: "B", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070006": {
    text: [{ text: "C", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070007": {
    text: [{ text: "D", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070008": {
    text: [{ text: "E", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070009": {
    text: [{ text: "F", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007000A": {
    text: [{ text: "G", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007000B": {
    text: [{ text: "H", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007000C": {
    text: [{ text: "I", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007000D": {
    text: [{ text: "J", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007000E": {
    text: [{ text: "K", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007000F": {
    text: [{ text: "L", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070010": {
    text: [{ text: "M", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070011": {
    text: [{ text: "N", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070012": {
    text: [{ text: "O", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070013": {
    text: [{ text: "P", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070014": {
    text: [{ text: "Q", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070015": {
    text: [{ text: "R", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070016": {
    text: [{ text: "S", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070017": {
    text: [{ text: "T", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070018": {
    text: [{ text: "U", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070019": {
    text: [{ text: "V", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007001A": {
    text: [{ text: "W", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007001B": {
    text: [{ text: "X", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007001C": {
    text: [{ text: "Y", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007001D": {
    text: [{ text: "Z", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007001E": {
    text: [
      { text: "!", style: { top: "30%", fontSize: "1.2em" } },
      { text: "1", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#0007001F": {
    text: [
      { text: "@", style: { top: "25%", fontSize: "1.2em" } },
      { text: "2", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070020": {
    text: [
      { text: "#", style: { top: "30%", fontSize: "1.2em" } },
      { text: "3", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070021": {
    text: [
      { text: "$", style: { top: "30%", fontSize: "1.2em" } },
      { text: "4", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070022": {
    text: [
      { text: "%", style: { top: "30%", fontSize: "1.2em" } },
      { text: "5", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070023": {
    text: [
      { text: "^", style: { top: "30%", fontSize: "1.2em" } },
      { text: "6", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070024": {
    text: [
      { text: "&", style: { top: "30%", fontSize: "1.2em" } },
      { text: "7", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070025": {
    text: [
      { text: "*", style: { top: "30%", fontSize: "1.2em" } },
      { text: "8", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070026": {
    text: [
      { text: "(", style: { top: "30%", fontSize: "1.2em" } },
      { text: "9", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070027": {
    text: [
      { text: ")", style: { top: "30%", fontSize: "1.2em" } },
      { text: "0", style: { top: "70%", fontSize: "1.2em" } },
    ],
  },
  "#00070028": { text: [{ text: "Enter", style: { top: "50%" } }] },
  "#00070029": { text: [{ text: "Esc", style: { top: "50%" } }] },
  "#0007002A": {
    text: [{ text: "Backspace", style: { top: "50%" } }],
  },
  "#0007002B": {
    text: [{ text: "Tab", style: { top: "50%" } }],
  },
  "#0007002C": {
    text: [{ text: "Space", style: { top: "50%" } }],
  },
  "#0007002D": {
    text: [
      { text: "_", style: { top: "15%", fontSize: "1.4em" } },
      { text: "-", style: { top: "60%", fontSize: "1.4em" } },
    ],
  },
  "#0007002E": {
    text: [
      { text: "+", style: { top: "30%", fontSize: "1.4em" } },
      { text: "=", style: { top: "65%", fontSize: "1.4em" } },
    ],
  },
  "#0007002F": {
    text: [
      { text: "{", style: { top: "25%", fontSize: "1.3em" } },
      { text: "[", style: { top: "70%", fontSize: "1.3em" } },
    ],
  },
  "#00070030": {
    text: [
      { text: "}", style: { top: "25%", fontSize: "1.3em" } },
      { text: "]", style: { top: "70%", fontSize: "1.3em" } },
    ],
  },
  "#00070031": {
    text: [
      { text: "|", style: { top: "25%", fontSize: "1.3em" } },
      { text: "\\", style: { top: "70%", fontSize: "1.3em" } },
    ],
  },
  "#00070033": {
    text: [
      { text: ":", style: { top: "25%", fontSize: "1.4em" } },
      { text: ";", style: { top: "65%", fontSize: "1.4em" } },
    ],
  },
  "#00070034": {
    text: [
      { text: '"', style: { top: "30%", fontSize: "1.4em" } },
      { text: "'", style: { top: "75%", fontSize: "1.4em" } },
    ],
  },
  "#00070035": {
    text: [
      { text: "~", style: { top: "30%", fontSize: "1.7em" } },
      { text: "`", style: { top: "90%", fontSize: "1.7em" } },
    ],
  },
  "#00070036": {
    text: [
      { text: "<", style: { top: "25%", fontSize: "1.8em" } },
      { text: ",", style: { top: "60%", fontSize: "1.3em" } },
    ],
  },
  "#00070037": {
    text: [
      { text: ">", style: { top: "25%", fontSize: "1.8em" } },
      { text: ".", style: { top: "60%", fontSize: "1.3em" } },
    ],
  },
  "#00070038": {
    text: [
      { text: "?", style: { top: "25%", fontSize: "1.5em" } },
      { text: "/", style: { top: "70%", fontSize: "1.4em" } },
    ],
  },
  "#00070039": {
    text: [
      { text: "Caps", style: { top: "35%" } },
      { text: "Lock", style: { top: "65%" } },
    ],
  },
  "#0007003A": { text: [{ text: "F1", style: { top: "50%" } }] },
  "#0007003B": { text: [{ text: "F2", style: { top: "50%" } }] },
  "#0007003C": { text: [{ text: "F3", style: { top: "50%" } }] },
  "#0007003D": { text: [{ text: "F4", style: { top: "50%" } }] },
  "#0007003E": { text: [{ text: "F5", style: { top: "50%" } }] },
  "#0007003F": { text: [{ text: "F6", style: { top: "50%" } }] },
  "#00070040": { text: [{ text: "F7", style: { top: "50%" } }] },
  "#00070041": { text: [{ text: "F8", style: { top: "50%" } }] },
  "#00070042": { text: [{ text: "F9", style: { top: "50%" } }] },
  "#00070043": { text: [{ text: "F10", style: { top: "50%" } }] },
  "#00070044": { text: [{ text: "F11", style: { top: "50%" } }] },
  "#00070045": { text: [{ text: "F12", style: { top: "50%" } }] },
  "#00070046": {
    text: [
      { text: "Print", style: { top: "35%" } },
      { text: "Screen", style: { top: "65%" } },
    ],
  },
  "#00070047": {
    text: [
      { text: "Scroll", style: { top: "35%" } },
      { text: "Lock", style: { top: "65%" } },
    ],
  },
  "#00070048": {
    text: [{ text: "Pause", style: { top: "50%" } }],
  },
  "#00070049": {
    text: [{ text: "Insert", style: { top: "50%" } }],
  },
  "#0007004A": {
    text: [{ text: "Home", style: { top: "50%" } }],
  },
  "#0007004B": {
    text: [
      { text: "Page", style: { top: "35%" } },
      { text: "Up", style: { top: "65%" } },
    ],
  },
  "#0007004C": {
    text: [{ text: "Delete", style: { top: "50%" } }],
  },
  "#0007004D": {
    text: [{ text: "End", style: { top: "50%" } }],
  },
  "#0007004E": {
    text: [
      { text: "Page", style: { top: "35%" } },
      { text: "Down", style: { top: "65%" } },
    ],
  },
  "#0007004F": {
    text: [{ text: "→", style: { top: "25%", fontSize: "1.7em" } }],
  },
  "#00070050": {
    text: [{ text: "←", style: { top: "25%", fontSize: "1.7em" } }],
  },
  "#00070051": {
    text: [{ text: "↓", style: { top: "25%", fontSize: "1.7em" } }],
  },
  "#00070052": {
    text: [{ text: "↑", style: { top: "25%", fontSize: "1.7em" } }],
  },
  "#00070053": {
    text: [
      { text: "Num", style: { top: "35%" } },
      { text: "Lock", style: { top: "65%" } },
    ],
  },
  "#00070054": {
    text: [{ text: "/", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070055": {
    text: [{ text: "*", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070056": {
    text: [{ text: "-", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070057": {
    text: [{ text: "+", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070058": {
    text: [{ text: "Enter", style: { top: "50%" } }],
  },
  "#00070059": {
    text: [{ text: "1", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007005A": {
    text: [{ text: "2", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007005B": {
    text: [{ text: "3", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007005C": {
    text: [{ text: "4", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007005D": {
    text: [{ text: "5", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007005E": {
    text: [{ text: "6", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#0007005F": {
    text: [{ text: "7", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070060": {
    text: [{ text: "8", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070061": {
    text: [{ text: "9", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070062": {
    text: [{ text: "0", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070063": {
    text: [{ text: ".", style: { top: "23%", fontSize: "1.7em" } }],
  },
  "#00070065": {
    text: [{ text: "Menu", style: { top: "50%" } }],
  },
  "#000700E0": {
    text: [
      { text: "Ctrl", style: { top: "35%" } },
      { text: "Left", style: { top: "65%" } },
    ],
  },
  "#000700E1": {
    text: [
      { text: "Shift", style: { top: "35%" } },
      { text: "Left", style: { top: "65%" } },
    ],
  },
  "#000700E2": {
    text: [
      { text: "Alt", style: { top: "35%" } },
      { text: "Left", style: { top: "65%" } },
    ],
  },
  "#000700E3": {
    text: [{ text: "Code", style: { top: "50%" } }],
  },
  "#000700E4": {
    text: [
      { text: "Ctrl", style: { top: "35%" } },
      { text: "Right", style: { top: "65%" } },
    ],
  },
  "#000700E5": {
    text: [
      { text: "Shift", style: { top: "35%" } },
      { text: "Right", style: { top: "65%" } },
    ],
  },
  "#000700E6": {
    text: [
      { text: "Alt", style: { top: "35%" } },
      { text: "Right", style: { top: "65%" } },
    ],
  },
  "#000700E7": {
    text: [{ text: "Code", style: { top: "50%" } }],
  },

  "#000C00E2": {
    text: [{ text: "Mute", style: { top: "50%" } }],
  },
  "#000C00E9": {
    text: [{ text: "VolUp", style: { top: "50%" } }],
  },
  "#000C00EA": {
    text: [{ text: "VolDn", style: { top: "50%" } }],
  },
  "#000C00B6": {
    text: [{ text: "|◀", style: { top: "50%" } }],
  },
  "#000C00B5": {
    text: [{ text: "▶|", style: { top: "50%" } }],
  },
  "#000C00CD": {
    text: [{ text: "▶ / ‖", style: { top: "50%" } }],
  },

  "#00920106": {
    text: [{ text: "BT_1", style: { top: "50%" } }],
  },
  "#00920107": {
    text: [{ text: "BT_2", style: { top: "50%" } }],
  },
  "#00920108": {
    text: [{ text: "BT_3", style: { top: "50%" } }],
  },
  "#00920130": {
    text: [
      {
        text: "2.4G",
        style: { top: "50%" },
      },
    ],
  },
  "#00920922": {
    text: [
      { text: "Win/", style: { top: "35%" } },
      { text: "Mac", style: { top: "65%" } },
    ],
  },
  "#00910001": {
    text: [
      { text: "System", style: { top: "35%" } },
      { text: "On/Off", style: { top: "65%", fontSize: "0.8em" } },
    ],
  },
  "#00900001": {
    text: [{ text: "Esc `", style: { top: "50%" } }],
  },
  "#009514C8": {
    text: [
      { text: "↑", style: { top: "35%" } },
      { text: "Shift", style: { top: "65%" } },
    ],
  },
  "#00920A02": {
    text: [{ text: "Reset", style: { top: "50%" } }],
  },
  "#00920A04": {
    text: [{ text: "Battery", style: { top: "50%" } }],
  },
  "#00920902": {
    text: [
      { text: "LED", style: { top: "35%" } },
      { text: "Light", style: { top: "65%" } },
    ],
  },
  "#00920903": {
    text: [
      { text: "LED", style: { top: "35%" } },
      { text: "On/Off", style: { top: "65%", fontSize: "0.8em" } },
    ],
  },
  "#00920900": {
    text: [
      { text: "Next", style: { top: "35%" } },
      { text: "LED", style: { top: "65%" } },
    ],
  },
  "#00920904": {
    text: [
      { text: "LED", style: { top: "35%" } },
      { text: "Speed+", style: { top: "65%", fontSize: "0.8em" } },
    ],
  },
  "#00920905": {
    text: [
      { text: "LED", style: { top: "35%" } },
      { text: "Speed-", style: { top: "65%", fontSize: "0.8em" } },
    ],
  },
  "#00920C0F": {
    text: [{ text: "Layer1", style: { top: "50%" } }],
  },
  "#00920C10": {
    text: [{ text: "Layer2", style: { top: "50%" } }],
  },
  "#00920C11": {
    text: [{ text: "Layer3", style: { top: "50%" } }],
  },
  "#00920C12": {
    text: [{ text: "Layer4", style: { top: "50%" } }],
  },
  "#00920C13": {
    text: [{ text: "Layer5", style: { top: "50%" } }],
  },
  "#00920C14": {
    text: [{ text: "Layer6", style: { top: "50%" } }],
  },
  "#00920C15": {
    text: [{ text: "Layer7", style: { top: "50%" } }],
  },
  "#00920C20": {
    text: [{ text: "Fn1", style: { top: "50%" } }],
  },
  "#00920C0B": {
    text: [{ text: "Fn2", style: { top: "50%" } }],
  },
  "#00920C22": {
    text: [{ text: "Fn3", style: { top: "50%" } }],
  },
  "#00920C23": {
    text: [{ text: "Fn4", style: { top: "50%" } }],
  },
  "#00920C24": {
    text: [{ text: "Fn5", style: { top: "50%" } }],
  },
  "#00920C25": {
    text: [{ text: "Fn6", style: { top: "50%" } }],
  },
  "#00920C26": {
    text: [{ text: "Fn7", style: { top: "50%" } }],
  },
  "#009514C9": {
    text: [{ text: "S Fn1", style: { top: "50%" } }],
  },
  "#009514CA": {
    text: [{ text: "S Fn2", style: { top: "50%" } }],
  },
  "#009514CB": {
    text: [{ text: "S Fn3", style: { top: "50%" } }],
  },
  "#009514CC": {
    text: [{ text: "S Fn4", style: { top: "50%" } }],
  },
  "#009514CD": {
    text: [{ text: "S Fn5", style: { top: "50%" } }],
  },
  "#009514CE": {
    text: [{ text: "S Fn6", style: { top: "50%" } }],
  },
  "#009514CF": {
    text: [{ text: "S Fn7", style: { top: "50%" } }],
  },
};
